import { isKeyOf } from '@cascade/core/utils';
import type { TMessageFeedbackType } from '@cascade/react/conversations';
import type { TFeedbackMark } from './ReplyControls.types.ts';

const feedbackMarks: Record<TMessageFeedbackType, TFeedbackMark> = {
  like: {
    iconType: 'thumbs-up',
    color: 'text-success',
    labelKey: 'agent.reply.liked',
  },
  dislike: {
    iconType: 'thumbs-down',
    color: 'text-danger',
    labelKey: 'agent.reply.disliked',
  },
};

export const getFeedbackMark = (
  feedback?: string,
): TFeedbackMark | undefined =>
  isKeyOf(feedbackMarks, feedback) ? feedbackMarks[feedback] : undefined;
